import {
  DEFERRED_SITENAME_AVAILABLE_PRODUCTS,
  DEFERRED_SITENAME_AVAILABLE_EDITIONS
} from '../../utility';
import { AppDispatch, RootState, FeatureFlagState } from '../';
import { ProductKeysType, ProductKey } from '@atlassiansox/bxpkit-core';

type DeferredSiteNameType = {
  readonly isEnabled: boolean;
};

type DeferredSiteNameThunkType = {
  readonly featureFlags: FeatureFlagState;
  readonly productKeys: ProductKeysType[];
};

type DeferredSiteNameActionType = {
  readonly type: string;
  readonly payload?: DeferredSiteNameType &
    DeferredSiteNameThunkType &
    ProductKeysType[];
};

// Actions
export const SET_STATUS = 'deferred-sitename/SET_STATUS';

// Initial State
export const initialState: DeferredSiteNameType = {
  isEnabled: false
};

// Reducer
export const deferredSiteNameReducer = (
  state = initialState,
  action: DeferredSiteNameActionType
): DeferredSiteNameType => {
  switch (action.type) {
    case SET_STATUS:
      const isEnabled =
        action.payload?.featureFlags.enableDeferredSiteName &&
        action.payload?.productKeys &&
        action.payload?.productKeys.length > 0 &&
        (action.payload?.productKeys[0].product === ProductKey.JIRA_SOFTWARE ||
          action.payload?.productKeys[0].product === ProductKey.CONFLUENCE) &&
        action.payload?.productKeys.filter(
          (p: ProductKeysType) =>
            p.product &&
            DEFERRED_SITENAME_AVAILABLE_PRODUCTS.includes(p.product) &&
            p.edition &&
            DEFERRED_SITENAME_AVAILABLE_EDITIONS.includes(p.edition)
        ).length === action.payload.productKeys.length;
      return { ...state, isEnabled: !!isEnabled };
    default:
      return state;
  }
};

// Thunks
export function updateDeferredSiteNameStatus() {
  return (dispatch: AppDispatch, getState: () => RootState) => {
    const { featureFlags, productKeys } = getState();
    dispatch({ type: SET_STATUS, payload: { featureFlags, productKeys } });
  };
}
